import React from "react";
import { Modal } from "react-bootstrap";
import { IconButtonType } from "../../interfaces/Components/IconButton/IIconButton";
import { IconButton } from "../IconButton/IconButton";
import { IDeleteConfirmation } from "../../interfaces/Components/DeleteConfirmation/IDeleteConfirmation";

import "./DeleteConfirmation.scss";

export const DeleteConfirmation: React.FC<IDeleteConfirmation> = ({
  title, item, isDeleting, onDelete, children, ...props
}) => {
  const className = `delete-confirmation ${props.className || ""}`;
  return (
    <Modal {...props} centered restoreFocus={false} className={className} aria-labelledby="delete-confirmation-title">
      <Modal.Header closeButton={false}>
        <Modal.Title id="delete-confirmation-title">{title}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {children}
      </Modal.Body>
      <Modal.Footer>
        <IconButton
          iconType={IconButtonType.Cancel}
          variant="secondary"
          onClick={props.onHide}
          disabled={isDeleting}
          aria-disabled={isDeleting}
        >
          Cancel
        </IconButton>
        <IconButton
          data-testid="delete-confirmation"
          iconType={IconButtonType.Delete}
          variant="danger"
          disabled={isDeleting}
          aria-disabled={isDeleting}
          spin={isDeleting}
          onClick={() => onDelete(item)}
        >
          Delete
        </IconButton>
      </Modal.Footer>
    </Modal>
  );
};
